import Vue from 'vue'

import VueLoading from 'vue-loading-overlay'
import VueSweetalert2 from 'vue-sweetalert2';
import Paginate from 'vuejs-paginate'
import VueTheMask from 'vue-the-mask'
import mixins from '@/mixins'

import 'vue-loading-overlay/dist/vue-loading.css'

export default {
  inject: () => {
    Vue.use(VueLoading)
    Vue.use(VueSweetalert2)
    Vue.mixin(mixins.CheckerMixin)
    Vue.component('paginate', Paginate)
    Vue.use(VueTheMask)
  }
}
